import React from "react"

export function Container({ children, ...rest }) {
  return (
    <div {...rest} className="container">
      {children}
    </div>
  )
}
